/* eslint no-param-reassign: "off" */
import moment from 'moment';

import * as types from './mutation-types';

export default {
  [types.ADD_AFSTEREO_DATE]: (state, payload) => {
    state.selectedDate = moment(state.selectedDate).add(payload.amount, payload.period);
  },
  [types.SUBTRACT_AFSTEREO_DATE]: (state, payload) => {
    state.selectedDate = moment(state.selectedDate).subtract(payload.amount, payload.period);
  },
  [types.SET_AFSTEREO_DATE]: (state, payload) => {
    state.selectedDate = moment(payload.date);
  },
  [types.SET_AFSTEREO_PERIOD]: (state, payload) => {
    state.selectedPeriod = payload.period;
  },
  [types.SET_AFSTEREO_STATION]: (state, payload) => {
    state.selectedStation = payload.station;
  },
  [types.GET_AFSTEREO_CHARTS_REQUEST]: state => {
    state.loadingCharts = true;
    state.loadingChartsFailed = false;
    state.loadingChartsSucceeded = false;
  },
  [types.GET_AFSTEREO_CHARTS_FAILURE]: (state, error) => {
    state.loadingCharts = false;
    state.loadingChartsFailed = true;
    state.laodingChartsError = error;
  },
  [types.GET_AFSTEREO_CHARTS_SUCCESS]: (state, response) => {
    state.loadingCharts = false;
    state.loadingChartsSucceeded = true;
    state.chartsData = response.data;
    state.selectedStation = response.data.current_station.station_id;
  },
  [types.GET_AFSTEREO_STATIONS_REQUEST]: state => {
    state.loadingStations = false;
    state.loadingStationsFailed = false;
    state.loadingStationsSucceeded = false;
  },
  [types.GET_AFSTEREO_STATIONS_FAILURE]: (state, error) => {
    state.loadingStations = false;
    state.loadingStationsFailed = true;
    state.loadingStationsError = error;
  },
  [types.GET_AFSTEREO_STATIONS_SUCCESS]: (state, response) => {
    state.loadingStations = false;
    state.loadingStationsSucceeded = true;
    state.stations = response.data.results;
  },
  [types.RESET_AFSTEREO_STATIONS_AREA]: state => {
    state.chartsData.stations.area = [['x']];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/afstereo/mutations.js